var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":true,"filterable":"","placeholder":_vm.label},model:{value:(_vm.selectId),callback:function ($$v) {_vm.selectId=$$v},expression:"selectId"}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item[_vm.vk],attrs:{"label":item[_vm.sk],"value":item[_vm.vk] || 0}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68ada692","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dropdown.vue
// module id = null
// module chunks = 